export default __webpack_public_path__ + "files/btn_test_normal.png";